<template>
  <div @click="showTask" :data-url="task.url">
    <a href="#" class="stretched-link"></a>
    
    <div class="list-group-item-figure">
      <span class="user-avatar user-avatar-md"><img :src="task.avatar" alt=""></span>
    </div>
    <div class="list-group-item-body">
      <h4 class="list-group-item-title mb-2 text-xl">{{ task.title }}</h4>
      <p class="list-group-item-subtitle text-muted small">{{ task.classification }}</p>
      <time class="text-sm text-muted" style="font-size: 0.9rem">{{ task.task_created_at }}</time>
    </div>
  </div>
</template>
<script>
  
  export default {
    name: 'TaskListItem',
    props: {
      task: {
        type: Object,
      },
    },
    data: vm => ({
      /**
       * Array of exclude task classifications. Tasks with this classification will not be shown in the sidebar, instead
       * the user will be redirected to the task's URL.
       */
      excluded: [
        'protocolo_pendiente',
        'protocolo_secundario_pendiente',
        'informe_final_no_aprobado_secretario',
        'informe_final_no_aprobado_comite',
      ],
    }),
    methods: {
      showTask() {
        if(this.excluded.indexOf(this.task.classification_key) === -1) {
          return this.$emit('show-task', this.task)
        }
        
         window.location = this.task.url
      },
    },
  }
</script>
